import { NormalizedGroup } from '../../../redux/groups/api/GroupAdapter';
import { BusinessRole } from '../redux/businessModel/model/model';

const normalizeCompanyName = (name: string): string => {
  return name.trim().toUpperCase().replace(/\s+/g, '');
};

const isCompanyNameMatch = (name1: string, name2: string): boolean => {
  if (!name1 || !name2) return false;
  return normalizeCompanyName(name1) === normalizeCompanyName(name2);
};

export const findMatchingCompany = (
  invitationCompanyName: string,
  availableCompanies: NormalizedGroup[]
): NormalizedGroup | undefined => {
  return availableCompanies.find((company) =>
    isCompanyNameMatch(company?.name, invitationCompanyName)
  );
};

export const isCompany = (group?: NormalizedGroup): boolean => {
  return group?.attributes?.BUSINESS_ROLE === BusinessRole.COMPANY;
};

export const isStore = (group?: NormalizedGroup): boolean => {
  return group?.attributes?.BUSINESS_ROLE === BusinessRole.STORE;
};
